import ManageActionColumn from "../../../components/common/BreadTabulatorActionButton.vue";

import Vue from "vue";
import Vuetify from "vuetify";
import store from "../../../store";
import router from "../../../router";

export default {
  serviceKey: "sso",
  key: "internalDepartment",
  column: {
    uid: "slug", // tell the system which column to be used as unique id
    text: "name", // tell the system which column to display as text
  },
  name: {
    singular: "Department",
    plural: "Departments",
  },
  parents: ["internalCompany"],

  apiUrls: {
    apiBrowseUrl: "",
    apiStoreUrl: "",
    apiUpdateUrl: "",
    apiReadUrl: "",
    apiMultiUpdateUrl: "",
    apiTrashedBrowseUrl: "",
    apiSoftDeleteUrl: "",
    apiHardDeleteUrl: "",
    apiRestoreUrl: "",
  },

  permissionKeys: {
    browse: "sso-internalDepartment-browse",
    read: "sso-internalDepartment-read",
    add: "sso-internalDepartment-add",
    edit: "sso-internalDepartment-edit",
    delete: "sso-internalDepartment-delete",
    restore: "sso-internalDepartment-restore",
    forceDelete: "sso-internalDepartment-forceDelete",
  },

  recordAccessControl: {
    browse: {
      all: {
        roles: ["superadmin"],
        apiUrl: "",
      },
      own: {
        roles: ["superadmin"],
        apiUrl: "",
      },
      assignedTo: {
        roles: ["salesperson", "sales-lead"],
        apiUrl: "",
      },
      belongsTo: {
        ssoBusiness: {
          roles: ["superadmin"],
          apiUrl: "",
        },
        ssoTeam: {
          roles: ["superadmin"],
          apiUrl: "",
        },
      },
    },
  },

  roleBasedFunctionalities: {
    browse: {
      all: ["superadmin"],
      own: ["salesperson"],
      team: ["sales-lead"],
    },
  },

  browse: {
    // alert:{
    //   text:[
    //     "Kindly contact superadmin if you need to add/edit/delete the data.",
    //   ],
    // },

    table: {
      actions: {
        manageCellEdit: false,
        columnSelectionDisabledCount: 3,
        isActionColumnVisible: true,
        isTrashedTabVisible: true,
      },
      headers: [
        {
          formatter: "rowSelection",
          titleFormatter: "rowSelection",
          titleFormatterParams: {
            rowRange: "active", //only toggle the values of the active filtered rows
          },
          hozAlign: "left",
          headerSort: false,
          filterable: false,
          searchable: false,
          selectableColumn: false,
          headerFilter: false,
          download: false,
          editable: false,
        },

        {
          title: "Index",
          formatter: (cell) => {
            return cell.getRow().getData().rownum;
          },
          filterable: false,
          searchable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: false,
          hozAlign: "left",
          download: false,
          editable: false,
        },

        {
          title: "Company",
          field: "internalCompanySlug",
          dataType: "modelParent",
          modelKey: "internalCompany",
          filterable: false,
          searchable: false,
          headerFilter: false,
          headerSort: true,
          selectableColumn: true,
          hozAlign: "left",
        },

        {
          title: "Name",
          field: "name",
          filterable: true,
          searchable: true,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          editable: false,
        },
        {
          title: "Slug",
          field: "slug",
          filterable: true,
          searchable: true,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          editable: false,
        },

        {
          title: "Total Roles",
          field: "_count.InternalRole",
          dataType: "integer",
          filterable: false,
          searchable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: true,
          hozAlign: "left",
        },

        /* {
          dataType: "model",
          relationship: "child",
          modelKey: "internalRole",
          text: "Total Roles",
          value: "internalRole",
          sortable: false,
          searchable: false,
          filterable: false,
        }, */

        {
          title: "Action",
          formatter: (cell) => {
            Vue.use(Vuetify);
            let ComponentClass = Vue.extend(ManageActionColumn);
            let instance = new ComponentClass({
              propsData: {
                cellData: cell.getData(),
                cellValue: cell.getValue(),
                cellRowData: cell.getRow().getData(),
                serviceKey: "sso",
                modelKey: "internalDepartment",
                modelId: cell.getRow().getData().id,
              },
              vuetify: new Vuetify({}),
              store,
              router,
            });
            instance.$mount();
            return instance.$el;
          },
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "internalRole", //key for tab
        label: "Roles",
        dataType: "model",
        relationship: "child",
        modelKey: "internalRole",
        mapping: {
          parent: "slug",
          child: "internalDepartmentSlug",
        },
      },
    ],
    table: {
      headers: [
        {
          dataType: "model",
          relationship: "parent",
          modelKey: "internalCompany",
          title: "Company",
          field: "internalCompanySlug",
        },
        {
          title: "Name",
          field: "name",
        },
        {
          title: "Slug",
          field: "slug",
        },
        /* {
          dataType: "model",
          relationship: "child",
          modelKey: "internalRole",
          text: "Total Roles",
        }, */
        {
          title: "Created",
          field: "timestampCreated",
        },
        {
          title: "Updated",
          field: "timestampUpdated",
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "model",
        key: "internalCompanySlug",
        name: "Company",
        modelKey: "internalCompany",
        optionText: "name",
        optionValue: "slug",
      },
      {
        type: "string",
        name: "Name",
        key: "name",
      },
      {
        type: "string",
        name: "Slug",
        key: "slug",
      },
    ],
    rules: {
      internalCompanySlug: ["required"],
      name: ["required"],
      slug: ["required"],
    },
  },
  edit: true,
  delete: true,
};
